'use client';
import React, { useState } from 'react';
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import * as z from "zod";
import axios from "axios";
import PhoneInput from 'react-phone-input-2';
import "react-phone-input-2/lib/material.css";
import "./phone.css";
import { Loader2 } from "lucide-react";
import { useToast } from "@/components/ui/use-toast"
import { Button } from "@/components/ui/button";
import {
  Form,
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select"
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { useTranslations } from 'next-intl';





const selectValues = [
  { id: "1", name: "1" },
  { id: "2-10", name: "2-10" },
  { id: "11-100", name: "11-100" },
  { id: "101-1000", name: "101-1000" },
  { id: "1000+", name: "1000+" },
];

export default function ContactForm() {
  const [submitting, setSubmitting] = useState(false);
  const { toast } = useToast();
  const t = useTranslations('contact-us.salesTeam.form');

  const formSchema = z.object({
    name: z.string().min(1, {
      message: t("error.nameRequired"),
    }),
    email: z.string().email({
      message: t("error.invalidEmail"),
    }).min(1, {
      message: t("error.emailRequired"),
    }),
    msg: z.string().min(1, {
      message:t("error.messageRequired"),
    }),
    phone: z.string().min(1, {
      message: t("error.phoneRequired"),
    }),
    employees: z.string().min(1, { message: t("error.employeeCountRequired") }),
  });

  const form = useForm<z.infer<typeof formSchema>>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      name: "",
      email: "",
      msg: "",
      employees: "",
    },
  });
  type FormValues = z.infer<typeof formSchema>;
  const { handleSubmit, control, setValue, formState: { errors } } = form;

  function onSubmit(data) {
    setSubmitting(true);
    axios.post('https://api.theos.ai/v1/contact/save/', {name:data.name, email:data.email, message:`I want to contact the theos sales copilot team, my phone number is +${data.phone}, we have ${data.employees} employees. Content: ${data.msg}`})
      .then((response) => {
        setSubmitting(false);
        form.reset();
        toast({
          title: t("toast.title"),
          description: t("toast.description"),
          variant: "default"
        })
      })
      .catch((error) => {
        setSubmitting(false);
      });
  }

  return (
    <Form {...form}>
      <form
        onSubmit={form.handleSubmit(onSubmit)}
        className="w-full space-y-4 "
      >
        <FormField
          control={form.control}
          name="name"
          render={({ field }) => (
            <FormItem>
              <FormLabel>{t("name.label")}</FormLabel>
              <FormControl>
                <Input placeholder={t("name.placeholder")} {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <FormField
          control={form.control}
          name="email"
          render={({ field }) => (
            <FormItem>
              <FormLabel>{t("email.label")}</FormLabel>
              <FormControl>
                <Input type="email" placeholder={t("email.placeholder")} {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={control}
          name="phone"
          render={({ field }) => (
            <FormItem>
              <FormLabel className={errors.phone ? 'text-destructive' : ''}>
                {t("phoneNumber.label")}
              </FormLabel>
              <FormControl>
                <PhoneInput
                  country={'us'}
                  value={field.value}
                
                  countryCodeEditable={true}
                  // buttonClass={'bg-input rounded-md'}
                  onChange={(phone: string) => setValue('phone', phone, { shouldValidate: true })}
                  
                  // error={errors.phone && errors.phone.message}
                  // inputExtraProps={{
                  //   required: true,
                  //   autoFocus: true,
                  // }}
                  inputClass={`
                  !bg-input
                  !rounded-md
                  !text-sm
                  !h-9
                
                  focus-visible:!ring-2
                  focus-visible:!ring-ring
                  focus-visible:!bg-contrast
                  !border-t-0
                  !border-l-0
                  !border-r-0
                  !border-b-2
                  !border-contrast
                  `}

                  dropdownClass={`
                  !bg-background
                  !border
                  !border-border
                  `}
                  searchClass={`
                  !bg-background

                  country:!bg-accent

                  last:!bg-input
                  last:!h-9
                  last:!rounded-md
                  last:!text-sm
                  last:!border-none
                  last:focus-visible:!ring-2
                  last:focus-visible:!ring-ring
                  last:focus-visible:!bg-contrast
                  `}
                  enableSearch
                />
              </FormControl>
              {errors.phone && (
                <FormMessage className="text-destructive">
                  {errors.phone.message}
                </FormMessage>
              )}
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="employees"
          render={({ field }) => (
            <FormItem>
              <FormLabel>{t("employeeCount.label")}</FormLabel>
              <Select onValueChange={field.onChange} defaultValue={field.value} >
                <FormControl>
                  <SelectTrigger className="w-40">
                    <SelectValue placeholder={t("employeeCount.placeholder")} />
                  </SelectTrigger>
                </FormControl>
                <SelectContent>
                  {selectValues.map((item) => (
                    <SelectItem key={item.id} value={item.id}>
                      {item.name}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>

              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="msg"
          render={({ field }) => (
            <FormItem>
              <FormLabel>{t("message.label")}</FormLabel>
              <FormControl>
                <Textarea placeholder={t("message.placeholder")} {...field} />
              </FormControl>
              <FormDescription>
              {t("messageNote")}
              </FormDescription>
              <FormMessage />
            </FormItem>
          )}
        />
        <div />
        <div className="w-full flex justify-end pt-8">
          <Button className="w-48" type="submit" disabled={submitting}>
            {submitting ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                {t("submitting")}
              </>
            ) : (
              t("submit")
            )}
          </Button>
        </div>
      </form>
    </Form>
  );
}




